// extracted by mini-css-extract-plugin
module.exports = {"banner-qr-box":"d","bannerQrBox":"d","qr-img-box":"e","qrImgBox":"e","qr-img-text":"f","qrImgText":"f"};